import BCMSSelectItem from "./BCMSSelectItem.jsx";

// Repersents data of selectable items in a BCMSSelect component:
export default class BCMSSelectData {

  constructor (value, label) {
    this.value = value;
    this.label = label === undefined ? value : label
  }

  toComponent() {
    return (<BCMSSelectItem label={this.label} value={this.value} />);
  }

  static init(value, label) {
    return new BCMSSelectData(value, label);
  }


  // :: [STRING|{label:value}|BCMSSelectData] -> [<BCMSSelectItem />]
  /*static initItems(items) {
    return items.map(item=>{

      if (item instanceof BCMSSelectData) {
        return item.toComponent();
      }

      thrown new Error("Cannot initalize BCMSSelectItem component with value of unsupported type")

    })
  }*/

}
